export enum Breakpoint {
  'min768' = '(min-width: 768px)',
  'min1024' = '(min-width: 1024px)',
  'min1280' = '(min-width: 1280px)',
  'min1440' = '(min-width: 1440px)',
  'min1680' = '(min-width: 1680px)',
}
